import { useRef, BaseSyntheticEvent } from 'react'
import useOutsideOnClick from 'hooks/useOutsideOnClick'
import Icon from 'common/Icon'
import styles from './index.module.scss'
import { SLATE_GRAY, WHITE } from 'constants/colors'
import Button from 'react-bootstrap/Button'
import classNames from 'classnames'

type FilterDropdownWrapperProps = {
  placeholder: string
  value?: string
  onPillClick: (shouldShow: boolean) => void
  disabled?: boolean
  showDropdown: boolean
  onClearValue: () => void
  labelClass?: string
  className?: string
}

const FilterDropdownWrapper: React.FC<FilterDropdownWrapperProps> = ({
  placeholder,
  value = '',
  children,
  onPillClick,
  disabled = false,
  showDropdown,
  onClearValue,
  labelClass = '',
  className = '',
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const hasValue = !!value

  const outsideClickCallback = () => {
    if (showDropdown) {
      onPillClick(false)
    }
  }

  useOutsideOnClick({ containerRef, callback: outsideClickCallback })

  return (
    <div ref={containerRef} className={classNames(className, styles.wrapper)}>
      {/* Clickable Pill That Opens Dropdown */}
      <Button
        variant="none"
        disabled={disabled}
        aria-label={placeholder + ' dropdown'}
        onClick={() => onPillClick(!showDropdown)}
        className={classNames('d-flex align-items-center', styles.new_pill, {
          [styles.pill_selected]: showDropdown || hasValue,
        })}
      >
        {/* Label */}
        <span
          className={classNames('mr-2', styles.pill_label, labelClass)}
          data-text={value || placeholder}
        >
          {value || placeholder}
        </span>

        {/* TODO: Not accessibility friendly to have nested interactions, but can't think of a good solution at the moment */}
        {hasValue ? (
          <div
            className={classNames(styles.close_icon, 'flex-center p-0 m-0')}
            onClick={(event: BaseSyntheticEvent) => {
              event.stopPropagation()
              onClearValue()

              if (showDropdown) {
                onPillClick(false)
              }
            }}
          >
            <Icon
              icon="filterCross"
              fill={WHITE}
              className={styles.close_icon}
            />
          </div>
        ) : (
          <Icon
            icon={showDropdown ? 'filterArrowUp' : 'filterArrowDown'}
            fill={showDropdown ? WHITE : SLATE_GRAY}
            className={styles.filter_icon}
          />
        )}
      </Button>

      {/* Dropdown Content */}
      {children}
    </div>
  )
}

export default FilterDropdownWrapper
